import React from 'react';
import { promptSamples } from '../../data/samplePrompts';
import { PromptDemo } from './PromptDemo';
import { PromptFlow } from './PromptFlow';
export function PromptExplainer() {
  return <section aria-label="See it in action" className="bg-white" data-id="element-271" data-mp="3hmbyv7esa9yz">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "25px",
      paddingBottom: "26px"
    }} data-id="element-272" data-mp="3hjzk134bofq5">
        <PromptDemo data-id="element-273" data-mp="37nmijj2jcxku" />

        <div className="mt-20" data-id="element-274" data-mp="37nczkffwrqon">
          <PromptFlow data-id="element-275" data-mp="37m30po18eegy" />
        </div>

        <div className="mt-20" data-id="element-276" data-mp="3cmpn72elt1sa">
          <h3 className="text-center font-display text-xl font-black text-ink sm:text-2xl" data-id="element-277" data-mp="3cmzaujc6ewut">Prompt samples</h3>
          <ul className="mt-8 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-278" data-mp="2yo9ghbgqrba5">
            {promptSamples.map(s => <li key={s.n} className="border-t border-line pt-5" data-id="element-279" data-mp="33mkqbm71dlsd">
                <p className="text-xs font-bold text-gold-ink" data-id="element-280" data-mp="wv1nx0c4ax6b">
                  #{s.n} <span className="font-semibold text-muted" data-id="element-281" data-mp="11uo33fbianhr">· {s.volume}</span>
                </p>
                <p className="mt-1.5 font-display text-base font-extrabold text-ink" data-id="element-282" data-mp="30hxrn3vxnnjx">{s.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-283" data-mp="2wgc6kv98w2yn">{s.desc}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}